import type { ProductOfferFragment } from '@/services/graphql/generated'

export const sortByPrice = (offerA: ProductOfferFragment, offerB: ProductOfferFragment) => {
  // Sort offers by gross price since adding a free months discount would set all net prices to 0
  if (offerA.cost.gross.amount < offerB.cost.gross.amount) return -1
  if (offerA.cost.gross.amount > offerB.cost.gross.amount) return 1
  return 0
}

export const sortByDeductibleAmount = (offerA: ProductOfferFragment, offerB: ProductOfferFragment) => {
  const amountA = offerA.deductible?.amount ?? 0
  const amountB = offerB.deductible?.amount ?? 0

  return amountA - amountB
}

export const sortByInsuranceAmount = (offerA: ProductOfferFragment, offerB: ProductOfferFragment) => {
  const amountA = offerA.insuranceAmount?.amount ?? 0
  const amountB = offerB.insuranceAmount?.amount ?? 0

  return amountA - amountB
}

export const getSortedOffersByPrice = (offers: Array<ProductOfferFragment>) => {
  return [...offers].sort((offerA, offerB) => {
    return sortByPrice(offerA, offerB)
  })
}

export const getTierPriority = (contractType: string): number => {
  const tier = contractType.toLowerCase()

  if (tier.includes('max') || tier.includes('premium') || tier.includes('full')) {
    return 1
  }
  if (tier.includes('half')) {
    return 2
  }
  if (tier.includes('bas') || tier.includes('basic') || tier.includes('traffic')) {
    return 3
  }
  // Standard is the default tier
  return 2
}

const sortByTierPriority = (offerA: ProductOfferFragment, offerB: ProductOfferFragment) => {
  return getTierPriority(offerA.variant.typeOfContract) - getTierPriority(offerB.variant.typeOfContract)
}

// Pet offers have no deductible variants, so price is what separates them
const sortByDeductibleOrPrice = (offerA: ProductOfferFragment, offerB: ProductOfferFragment) => {
  return offerA.product.name.includes('SE_PET') ? sortByPrice(offerA, offerB) : sortByDeductibleAmount(offerA, offerB)
}

export const getSortedOffers = (offers: Array<ProductOfferFragment>) => {
  return [...offers].sort(
    (offerA, offerB) =>
      sortByTierPriority(offerA, offerB) ||
      sortByDeductibleOrPrice(offerA, offerB) ||
      sortByInsuranceAmount(offerA, offerB),
  )
}
